import React from "react";

import { translate } from "react-i18next";

import { DynamicForm } from "src/components/Form";
import { Box } from "src/components";

import { ssnField } from "src/banking/authentication/sharedFields";

const formFieldProps = {
  labelTop: true,
  autoComplete: "off",
};

const fields = ({ t }) => [
  {
    type: "section",
    title: t("olb.login.forgotUsernameTitle", {
      defaultValue: "Forgot Username",
    }),
    fields: [
      {
        key: "acn",
        label: "Member Number",
        required: true,
        inputProps: {
          format: value => {
            // Strip out non-numeric values
            const digits = (value || "").match(/\d/g) || [];
            return digits.join("");
          },
          ...formFieldProps,
        },
      },
      ssnField({ inputProps: formFieldProps, t }),
    ],
  },
];

const EntryForm = ({ history, t, ...props }) => (
  <Box my={2}>
    <DynamicForm
      formKey="forgotUsername"
      fields={fields}
      needsCaptcha={false}
      {...props}
    />
  </Box>
);

export default translate("translations")(EntryForm);



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotLogin/ForgotUsername/steps/Entry.js